module.exports = __webpack_public_path__ + "img/service_icon7-pressed.95d50bb6.png";